import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Backend } from '@dentalux/i18next-plugins'

import deTranslations from '../i18n/de.json'
import enTranslations from '../i18n/en.json'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const init = (): any => {
  return i18n
    .use(initReactI18next)
    .use(Backend)
    .init({
      backend: {
        applicationName: 'insight-frontend',
        fallbackResource: {
          en: enTranslations,
          de: deTranslations,
        },
      },
      lng: 'de',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const testInit = (resources: any): Promise<any> => {
  return i18n.use(initReactI18next).init({
    resources: {
      en: { translation: resources.en },
      de: { translation: resources.de },
    },
    lng: 'de',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
}

export default i18n
